<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_v">AUTHOR’S NOTE</a></p><a id="page_v">
<p class="noindent">With the understanding that the nature of memory is ephemeral, the following is true and factual based on my knowledge and memory. In the name of narrative flow, I have in some instances re-created dialogue, collapsed time, and reimagined certain details and conversations, but the story and all events herein are true. Some names have been changed to protect the identities of individuals.</p>
<p class="pgbr">
</p></a><p class="poem2" id="epi"><a id="page_v"></a><a id="page_vi">“all these years of death later</a></p><a id="page_vi">
<p class="poem2">I search through the index</p>
<p class="poem2">of each new book on magic</p>
<p class="poem2">hoping to find a new spelling</p>
<p class="poem2">of your name”</p>
<p class="poem2t"> AUDRE LORDE, “Alvin”</p>
<p class="quote-in">“I know what the world has done to my brother and how narrowly he has survived it. And I know, which is much worse, and this is the crime which I accuse my country and countrymen, and for which I nor time nor history will ever forgive them, that they have destroyed and are destroying hundreds of thousands of lives and do not know it and do not want to know it.”</p>
<p class="right1">JAMES BALDWIN, <i>The Fire Next Time</i></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_FM01.vue?3a4da7a1